import { useSelector } from 'react-redux';
import { getIsLoading } from '../stores/algo-edit-config/getters';

function useAlgoLoading() {
  const loading = useSelector(getIsLoading);

  return loading;
}

export default useAlgoLoading;
